import PropTypes from "prop-types";
import React, { Component } from "react";
import styled from "styled-components";
import { nativeRedirectToPage } from "../../utilities/native";
import util from "../../utilities/util";
import VDSButtonWrapper from "./VDSButtonWrapper";
import common from "../../utilities/util";
import copy from 'copy-to-clipboard';
import { Button } from "@vds/buttons";
import { Icon } from "@vds/icons";
//import { logClickStream, logDisplayedError } from '../utilities/logger';
//import omnitagging from '../utilities/omnitagging';
const StyledDiv = styled.div`
    width: 100%;
    
    
    height: 120px;
    margin-left: 10%;

`;
const StyledButton = styled(Button)`
font-size: 14px;
background-color: black;
padding-top: 6px;
height: 36px;
margin-left: 20%;
`


// const ScrollableSection = styled.div`
//   overflow: auto;
//   margin: 0 -20px;
//   padding: ${ props => (props.isTrialUnlimited || props.isMMPlans ) ? `0 40px` : `0 20px`};
//   flex-grow: 1;

// `;


// const Button = styled.a`
//   display: inline-block;
//   padding: 9px;
//   text-align: center;
//   color: #fff;
//   background-color: #000;
//   border: 0;
//   cursor: pointer;
//   font-family: NeueHaasGroteskDisplay, Arial, Helvetica, sans-serif;
//   font-size: 12px;
//   font-weight: bold;
//   font-size: 1.28rem;
//   width: 55%;
//   min-width: 84px;
//   border-radius: 24px;
//   border: 1px solid #000;
//   text-decoration: none;
//   : visited {
//     color: #fff !important;
//   }
//   : hover {
//     color: #fff !important;
//   }
// `;

export default class TileInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false
    };
  }
  static propTypes = {
    isVisible: PropTypes.bool,
    htmlMessage: PropTypes.string,
    htmlSubMessage: PropTypes.any,
    htmlDescMessage: PropTypes.string,
    htmlactionName: PropTypes.string,
    htmlactionValue: PropTypes.string,
    divClass: PropTypes.string,
    isTrialUnlimited: PropTypes.bool,
    htmlHideButton: PropTypes.bool,
    isPendingOrder: PropTypes.bool,
    errorcode: PropTypes.string,
    jsError: PropTypes.bool
  };
  static defaultProps = {
    isVisible: false,
    htmlMessage: "Please try after sometime.",
    htmlSubMessage: "",
    htmlDescMessage: "Your request could not be processed at this time. Please try again later.",
    htmlActionName: "",
    htmlActionValue: "",
    divClass: "w_msg-banner m_bg-orange",
    isTrialUnlimited: false,
    htmlHideButton: false,
    isPendingOrder: false,
    errorcode: 'B-99',
    jsError: false
  };
  copyToClip = (offerId) => {
    // let sfoId= document.getElementById("sfo").getAttribute("value");
    copy(offerId);
  };
  handleClick = (htmlActionValue) => {
    const channelId = util.getChannelId();
    // if (channelId && channelId === "VZW-MFA") {
    //   nativeRedirectToPage("accountLanding");
    // } else {
    //   window.location.href = htmlActionValue;
    // }
    this.props && this.props.history && this.props.history.push('/')
    
  };

  componentDidMount() {
    let errMsgDisplayed = this.props.htmlMessage + ' ' + this.props.htmlDescMessage;
    let errCode = this.props.errorcode;
    if (!(errCode == 'B-99')) {
      errCode = "B-" + errCode;
    }
    if (this.props.jsError) {
      errCode = "B-JS-ERR";
    }
    //logClickStream(errMsgDisplayed, errCode, "ERROR_SHOWN");
    //logDisplayedError(errMsgDisplayed, errCode);
    //omnitagging.setError(errMsgDisplayed, errCode);
  }

  render() {
    const {
      isVisible,
      isTrialUnlimited,
      htmlMessage,
      htmlSubMessage,
      htmlDescMessage,
      htmlActionName,
      htmlActionValue,
      htmlHideButton,
      divClass,
      isPendingOrder,
      isMMPlans,
      offerId, offerName,
      isAccordionError,
      flowName

    } = this.props;

    return (
      <React.Fragment>
        <div>
          <div className={isAccordionError ? "" : "vh70"}>
            <div className="pad24 textAlignCenter">
              <div className="margin48 onlyTopMargin">
                <i className="f-icon_sad" alt="sadIcon"></i>
              </div>
              <h2 className="fontSize_5" dangerouslySetInnerHTML={{ __html: htmlMessage }} />
              <p className="fontSize_2" dangerouslySetInnerHTML={{ __html: htmlDescMessage }}/>
              <div style={{ "display": "grid", "alignItems": "center", "justifyContent": "center" }} >
                {!(flowName == "accsConfirmation") &&
                  <VDSButtonWrapper
                    isExtraPadding={true}
                    primaryButtonText={"Home"}
                    primaryButtonAnalytics={"Home"}
                    primaryButtonClickStream={"Home"}
                    onPrimaryButtonClick={() => {
                      this.handleClick(htmlActionValue)
                      //("accountLanding");
                    }}
                  />
                }
                {(flowName == "accsConfirmation") &&

                  <div style={{ borderStyle: "groove", width: "130%", marginTop: "5%", marginLeft: "-10%" }}>
                    <p style={{ marginTop: '3%', marginBottom: '2%', fontWeight: 'bolder', fontSize: '18px' }}>{common.isACSS() ? "Place order in ACSS Order screen for selected plans" : "Place order in POS service through the shop services link" }</p>
                    <StyledDiv size="large">
                      <div style={{ display: "flex", paddingBottom: "1%", paddingLeft: "4%", paddingTop: "2%", backgroundColor: "whitesmoke", marginBottom: "2%", width: "80%" }}>
                        <div
                          style={{ paddingLeft: '30px' }}>
                          <h1 style={{ fontSize: '14px' }}>Code</h1>
                          <span id="sfo" value={offerId} style={{ fontSize: '14px' }}>SPO&nbsp;{offerId}</span>
                        </div>
                        <div style={{ paddingLeft: '27%' }}>
                          <h1 style={{ fontSize: '14px' }}>Name</h1>
                          <span style={{ fontSize: '14px' }}>{offerName}</span>
                        </div>
                      </div>
                      <StyledButton onClick={() => { this.copyToClip(offerId) }}><p style={{ marginTop: '-10px', color: 'white' }}><Icon
                        name="duplicate"
                        color="white"
                        size="small"
                      />
                        &nbsp; Copy  SPO </p></StyledButton>
                    </StyledDiv>
                  </div>


                }




              </div>
            </div>
          </div>
          <div className="textAlignCenter">
            {/* <div>
              <a href="https://myaccount.verizonwireless.com/clp/login?redirect=/myv/overview/" id="primary" class="button margin10 primary undefined">
                Home
              </a>
            </div> */}
            {/* <VDSButtonWrapper
              isExtraPadding={isMMPlans}
              primaryButtonText={"Home"}
              primaryButtonAnalytics={"Home"}
              primaryButtonClickStream={"Home"}
              onPrimaryButtonClick={() => {
                //("accountLanding");
              }}
            /> */}
          </div>
        </div>
        {/* <ScrollableSection isTrialUnlimited={isTrialUnlimited} isPendingOrder={isPendingOrder} isMMPlans={isMMPlans}>
          <div style={typeof htmlSubMessage === "object" ? { height: "" } : { height: "50vh" }}>
            <div style={{ padding: "4px" }}>
              <h2 style={{ fontSize: "29px" }} dangerouslySetInnerHTML={{ __html: htmlMessage }}></h2>
              {htmlDescMessage && (
                <p style={{ fontSize: "14px" }} dangerouslySetInnerHTML={{ __html: htmlDescMessage }}></p>
              )}
            </div>
          </div>
        </ScrollableSection>
        {
          //_isNative && !isTrialUnlimited ? 
          (
            <VDSButtonWrapper
              isExtraPadding={isMMPlans}
              primaryButtonText={"Retry"}
              primaryButtonAnalytics={"Retry"}
              primaryButtonClickStream={"Retry"}
              onPrimaryButtonClick={() => {
                //("accountLanding");
              }}
            />

          )
          // : (
          //     !htmlHideButton && htmlActionName && (
          //       <VDSButtonWrapper 
          //         primaryButtonText={htmlActionName}
          //         primaryButtonAnalytics={htmlActionName}
          //         onPrimaryButtonClick={() => this.handleClick(htmlActionValue)}
          //       />

          //     )
          //   )
        } */}
      </React.Fragment>
    );
  }
}
